import { t } from 'i18next'
import React, { useContext, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Spinner } from 'reactstrap'
import { ButtonBlue } from '../../components/Buttons/ButtonBlue'
import { CustomAlert } from '../../components/CustomAlert/CustomAlert'
import PasswordInput from '../../components/Inputs/PasswordInput'
import LoginContext from '../../context/LoginContext/LoginContext'
import useCheckNewPasswordToken from '../../customHooks/useCheckNewPasswordToken'
import ErrorScreen from '../../components/MessagesScreens/ErrorScreen'

const ChangePassword = () => {

  const { password_auth, user_name } = useParams();
  const { loginState, sendNewPassword } = useContext(LoginContext);
  const { forgotPassword } = loginState;

  const { isFetchingNewPasswordToken, errorNewPasswordToken, messageNewPasswordToken } = useCheckNewPasswordToken(user_name, password_auth);

  const [newPassword, setNewPassword] = useState({ password: '', confirmPassword: '' });

  const haveLowerCase = /[a-z]/.test(newPassword.password);

  const haveUpperCase = /[A-Z]/.test(newPassword.password);

  const haveNumbers = /[0-9]/.test(newPassword.password);

  const haveLength = newPassword.password.length >= 8 && newPassword.password.length <= 50

  const haveEvery = haveLowerCase && haveUpperCase && haveNumbers && haveLength

  const validations = [
    {
      name: t('MIN_EIGHT_MAX_FIFTY_CARACT'),
      validation: haveLength
    },
    {
      name: t('UPPERCASE'),
      validation: haveUpperCase
    },
    {
      name: t('LOWERCASE'),
      validation: haveLowerCase
    },
    {
      name: t('NUMBER'),
      validation: haveNumbers
    },
  ]

  const disabled = newPassword.confirmPassword !== newPassword.password || !!!newPassword.confirmPassword.trim() || !!!newPassword.password.trim() || !!!haveEvery || newPassword.password === user_name

  const handleChange = (e) => {
    const { value, name } = e.target;
    setNewPassword({
      ...newPassword,
      [name]: value
    })
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (disabled) return
    sendNewPassword({ password: newPassword.password, password_auth, user_name })
  }

  return (
    <div className='pe-4 ps-4'>
      {isFetchingNewPasswordToken && (
        <div className="d-flex justify-content-center">
          <Spinner />
        </div>
      )}
      {errorNewPasswordToken && (
        <ErrorScreen
          title={'Error'}
          description={messageNewPasswordToken}
        />
      )}
      {(isFetchingNewPasswordToken === false && errorNewPasswordToken === false) && (
        <div>
          <h4 className='m-0 custom h3'>
            {t('WRITE_NEW_PASS')}
          </h4>
          <form className='d-flex flex-column mt-4 gap-3' onSubmit={handleSubmit}>
            {forgotPassword.error ? <CustomAlert text={forgotPassword.message} color={'danger'} /> : null}

            <div>
              <label
                htmlFor="password"
                className="form-label blue-dark-text"
              >
                {t('PASSWORD')}
              </label>
              <PasswordInput
                name={"password"}
                value={newPassword.password}
                onChange={handleChange}
              />
            </div>

            {
              newPassword.password.length > 0 ?
                <div className='d-flex flex-column gap-2 mb-3'>
                  {
                    validations.map((validation, idx) =>
                      <div key={idx} className='d-flex align-items-center gap-2'>
                        <i
                          style={{ color: validation.validation ? '#35E6B0' : '#DBDDED' }}
                          className="fa-solid fa-circle-check"
                        >
                        </i>
                        <span className='blue-dark-text-low-size'>
                          {validation.name}
                        </span>
                      </div>
                    )
                  }
                </div>
                :
                null
            }

            <div>
              <label
                htmlFor="confirmPassword"
                className="form-label blue-dark-text"
              >
                {t('CONFIRM_PASS')}
              </label>
              <PasswordInput
                placeholder={'Confirma tu contraseña'}
                name={"confirmPassword"}
                value={newPassword.confirmPassword}
                onChange={handleChange}
              />
            </div>

            <div className="mt-4">
              {
                forgotPassword.isFetching ?
                  <div className="d-flex justify-content-center">
                    <Spinner />
                  </div>
                  :
                  <ButtonBlue
                    className='w-100'
                    type='submit'
                    disabled={disabled}
                  >
                    {t('CREATE_PASS')}
                  </ButtonBlue>
              }
            </div>
          </form>
        </div>
      )}
    </div>

  )
}

export default ChangePassword